<template>
  <div class="balloon balloon-generic" @click.shift.left.exact="bubbleShift">
    <v-carousel
      height="auto"
      hide-delimiters
      :show-arrows="message.payloads.length > 1"
    >
      <v-carousel-item v-for="(obj, j) in message.payloads" :key="j">
        <v-sheet color="white">
          <div class="generic-template">
            <img v-if="obj.image_url" :src="obj.image_url" />
            <div class="generic-template-title">
              <div>{{ obj.title }}</div>
              <div>{{ obj.subtitle }}</div>
            </div>
            <div
              v-for="(button, k) in obj.buttons"
              :key="k"
              class="generic-template-content"
            >
              <div>{{ button.title }}</div>
            </div>
          </div>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: 'PayloadGeneric',
  props: {
    conversation: Object
  },
  data() {
    return {
      message: {},
      sender: ''
    }
  },
  watch: {
    conversation: {
      immediate: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender
      }
    }
  },
  methods: {
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    }
  }
}
</script>
